if (!window.Eurus.loadedScript.includes('variant-select.js')) {
  window.Eurus.loadedScript.push('variant-select.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xVariantSelect', (
        element,
        sectionId,
        isProductPage,
        unavailableText,
        productUrl,
        productId,
        showFirstImageAvaiable,
        productBundle,
        handleSectionId,
        firstAvailableVariantId,
        pageParam
      ) => ({
        variants: null,
        currentVariant: {},
        options: [],
        currentAvailableOptions: [],
        existingOptions : [] ,
        cachedResults: [],
        quickViewSectionId: 'quick-view',
        handleSectionId: sectionId,
        paramVariant: false,
        mediaGallerySource: [],
        isChange: false,
        mediaOptions: '',
        handleSticky: '',
        initfirstMedia: false,

        get isProductPage (){

            const url = new URL(location.href)

            return url.pathname.includes(`/products/`)
        },

        initVariant (){

            this.variants = this.loadConfig()

            if( productBundle )
                this.handleSectionId = handleSectionId
            else {

                document.addEventListener('eurus:cart:items-changed',() => {

                    this.cachedResults = []

                    Alpine
                    .store('xUpdateVariantQuanity')
                    .updateQuantity(sectionId,productUrl,this.currentVariant?.id)
                })
            }

            this.$watch('options',() => {
                this._updateVariantSelector()
            })
        },


        loadConfig (){

            const script = this.$el.querySelector
                ( `[ type = 'application/json' ]` )

            const json = script.textContent

            const data = JSON.parse(json)

            return data
        },


        initMedia (){

            this.initfirstMedia = true

            this._updateMasterId();
            this._updateMedia();

            this.initfirstMedia = false
        },


        _updateVariantSelector (){

            this._updateMasterId()
            this._updateVariantStatuses()

            console.warn('Current Variant [ Default ] ',{
                variant : this.currentVariant
            })

            if( ! this.currentVariant ){

                const available = this._findAvailableVariant()

                if( available ){

                    console.debug('Available',available)

                    available.options.find(( option , index ) => {

                        const selector =
                            `input[ x-model = 'options[${ index }]' ]` +
                            `[ value = '${ option }' ]`

                        console.debug('Selector',{ selector })

                        const input = this.$el.querySelector(selector)

                        console.debug('Input',input)

                        if( input.checked )
                            return false

                        input.click()

                        return true
                    })

                } else {
                    this._dispatchUpdateVariant()
                    this._setUnavailable()
                }

                return
            }

            console.warn('Current Variant [ After ] ',{
                variant : this.currentVariant ,
                options : this.currentAvailableOptions ,
                existing : this.existingOptions
            })


            if( firstAvailableVariantId != this.currentVariant.id )
                this.paramVariant = true

            if( this.isProductPage && this.paramVariant ){

                console.debug('Variant-Select::UpdateVariantSelector',{
                    isProductPage : this.isProductPage
                })

                const variant = this.currentVariant.id

                const url = new URL(location.href)
                url.searchParams.set('variant',variant)

                history.replaceState(history.state,'',url.href)
            }

            if( ! this.isProductPage )
                this._updateImageVariant()

            this._updateVariantInput()
            this._updateProductForms()
            this._setAvailable()

            Alpine
            .store('xPickupAvailable')
            .updatePickUp(sectionId, this.currentVariant.id)

            const cacheKey = `${ sectionId }-${ this.currentVariant.id }`

            if( this.cachedResults[ cacheKey ] )
                this._renderCached(cacheKey)
            else
                this._renderUncached(cacheKey)
        },

        _renderCached ( cacheKey ){

            const html = this.cachedResults[ cacheKey ]

            this._renderPriceProduct(html)
            this._renderSkuProduct(html)
            this._renderProductBadges(html)
            this._renderInventoryStatus(html)

            this._updateMedia(html)

            this._updateSlots(html)

            this._renderBuyButtons(html)
            this._setMessagePreOrder(html)
            this._setEstimateDelivery(html)
            this._setTableOfInformation(html)
            this._setCartEstimateDelivery(html)
            this._setPreorderProperties(html)
            this._setBackInStockAlert(html)
            this._setPickupPreOrder(html)

            if( this.currentVariant.featured_media != null )
                this._updateColorSwatch(html)

            this._dispatchUpdateVariant();
            this._dispatchVariantSelected(html);

            if( ! productBundle )
                Alpine
                .store('xUpdateVariantQuanity')
                .render(html, sectionId)
        },

        _renderUncached ( cacheKey ){

            const variantId = this.currentVariant.id

            const url = new URL(productUrl,location.href)
            url.searchParams.set('variant',variantId)

            fetch(url)
            .then((response) => response.text())
            .then((responseText) => {

                const html = new DOMParser()
                    .parseFromString(responseText, 'text/html');

                if(
                    this.currentVariant &&
                    variantId == this.currentVariant.id &&
                    html.getElementById(`x-product-template-${productId}-${sectionId}`)
                ){

                    this._renderPriceProduct(html)
                    this._renderSkuProduct(html)
                    this._renderProductBadges(html)
                    this._renderInventoryStatus(html)

                    if( showFirstImageAvaiable )
                        this._updateMedia(html)
                    else
                    if( this.isChange )
                        this._updateMedia(html)

                    this._updateSlots(html)

                    this._renderBuyButtons(html)
                    this._setMessagePreOrder(html)
                    this._setEstimateDelivery(html)
                    this._setTableOfInformation(html)
                    this._setPickupPreOrder(html)
                    this._setCartEstimateDelivery(html)
                    this._setPreorderProperties(html)
                    this._setBackInStockAlert(html)

                    if( this.currentVariant.featured_media != null )
                        this._updateColorSwatch(html)

                    if( ! productBundle )
                        Alpine
                        .store('xUpdateVariantQuanity')
                        .render(html, sectionId)

                    this.cachedResults[ cacheKey ] = html

                    this._dispatchUpdateVariant(html)
                    this._dispatchVariantSelected(html)

                } else
                if( this.currentVariant && variantId == this.currentVariant.id )
                    this._dispatchUpdateVariant(html)
            })
        },


        _dispatchVariantSelected ( html ){

            const name = `eurus:product-page-variant-select:updated:${ sectionId }`

            const detail = {
                currentAvailableOptions : this.currentAvailableOptions ,
                currentVariantStatus : this.currentVariant?.available && ! this.currentVariant?.hidden ,
                existingOptions : this.existingOptions ,
                options : this.options ,
                html : html
            }

            const event = new CustomEvent(name,{ detail })

            document.dispatchEvent(event)
        },


        _updateVariantStatuses (){

            console.debug('Options',this.options)

            const relevant = this.variants
                // .filter(( variant ) => variant.available )
                .filter(( variant ) => ! variant.hidden )
                .filter(( variant ) => this.options[ 0 ] === this._decodeOptionValue(variant.option1) )

            console.debug('Relevant',relevant)

            this.options.forEach(( option , index0 ) => {

                this.currentAvailableOptions[ index0 ] = []
                this.existingOptions[ index0 ] = []

                const isPrimary = ( index0 === 0 )

                if( isPrimary )
                    return

                const selected = this.options[ index0 - 1 ]

                relevant.forEach(( variant ) => {

                    let current = variant[ `option${ index0 }` ]

                    current = this._decodeOptionValue(current)

                    if( current !== selected )
                        return

                    let next = variant[ `option${ index0 + 1 }` ]

                    next = this._decodeOptionValue(next)

                    this.existingOptions[ index0 ].push(next)

                    if( variant.available )
                        this.currentAvailableOptions[ index0 ].push(next)
                })
            })
        },


        _decodeOptionValue ( option ){
            return option?.replaceAll('\\/','/')
        },


        _renderInventoryStatus ( html ){

            const id = `#block-inventory-${ sectionId }`

            const destination = document.querySelector(id)

            if( ! destination )
                return

            source = html.querySelector(id)

            if( ! source )
                return

            destination.innerHTML = source.innerHTML
        },

        _updateSlots (
            html
        ){

            const Parts = {
                Section : `.shopify-section` ,
                Slots : `[ data-slot ]`
            }

            document
            .querySelectorAll(Parts.Slots)
            .forEach(( slot ) => {

                const type = slot.dataset.slot

                const parent = slot
                    .closest(Parts.Section)

                if( ! parent ){
                    console.warn(`Slot is not in recognized section.`,{ slot , type })
                    return
                }

                const sectionId = parent.id

                const Part_Section = `#${ sectionId }`

                const section = html
                    .querySelector(Part_Section)

                if( ! section ){
                    console.warn(`The slot's section is not present in the data.`,{ slot , type , sectionId })
                    return
                }


                let Part_Slot = `[ data-slot = '${ type }' ]`

                const uid = slot.dataset.uid

                if( uid )
                    Part_Slot += `[ data-uid = '${ uid }' ]`

                const slots = section
                    .querySelectorAll(Part_Slot)

                if( slots.length === 0 ){
                    console.warn(`The slot is not present in the data.`,{ slot , type , uid , sectionId })
                    return
                }

                if( slots.length > 1 ){
                    console.warn(`The slot ambiguous in the data.`,{ slot , type , uid , sectionId })
                    return
                }

                const data = slots.item(0)

                const template = data
                    .querySelector(`& > * > template`)

                // console.debug('Template',template,slot)

                if( template )
                    slot
                    .querySelector(`& > div`)
                    .shadowRoot.innerHTML = template.innerHTML
                else
                    slot.innerHTML = data?.innerHTML ?? ''
            })
        },

        _updateMedia(html) {

            const element = document.getElementById
                ( `product-media-${ sectionId }` )

            let mediaWithVariantSelected = element
                ?.dataset.mediaWithVariantSelected === 'true'

            console.debug({ mediaWithVariantSelected })

            if (!productBundle && !mediaWithVariantSelected) {

                let splideEl = document
                    .getElementById("x-product-" + sectionId);

                let slideVariant = ""
                let activeEL = ""
                let index = ""

                if (this.currentVariant && this.currentVariant.featured_media != null) {
                    slideVariant = document.getElementsByClassName(this.currentVariant.featured_media.id + '-' + sectionId);
                    index = parseInt(slideVariant[0]?.getAttribute('index'));
                    activeEL = document.getElementById('postion-image-' + sectionId + '-' + this.currentVariant.featured_media.id);
                } else {
                    slideVariant = splideEl.querySelector(".featured-image");
                    index = parseInt(slideVariant?.getAttribute('index'));
                    activeEL = document.querySelector(`#stacked-${sectionId} .featured-image`);
                }

                if (splideEl) {

                    if (splideEl.splide && slideVariant) {
                        splideEl.splide.go(index)
                    } else {

                        document.addEventListener(`eurus:media-gallery-ready:${sectionId}`, () => {

                            if (splideEl.splide)
                                splideEl.splide.go(index);
                        });
                    }
                }

                if (!activeEL)
                    return;


                if (html && !mediaWithVariantSelected) {

                    let mediaGalleryDestination = html
                        .getElementById(`stacked-${ sectionId }`);

                    let mediaGallerySource = document
                        .getElementById(`stacked-${ sectionId }`);

                    if (mediaGallerySource && mediaGalleryDestination) {

                        let firstChildSource = mediaGallerySource
                            .querySelectorAll('div[data-media-id]')[0];

                        let firstChildDestination = mediaGalleryDestination
                            .querySelectorAll('div[data-media-id]')[0];

                        if (firstChildDestination.dataset.mediaId != firstChildSource.dataset.mediaId && firstChildSource.dataset.index != 1) {

                            let sourceIndex = parseInt(firstChildSource.dataset.index);
                            let positionOld = mediaGallerySource.querySelector(`div[data-media-id]:nth-of-type(${sourceIndex + 1})`);
                            mediaGallerySource.insertBefore(firstChildSource, positionOld);
                        }

                        mediaGallerySource.prepend(activeEL);
                    }
                }
            }

            if (mediaWithVariantSelected) {
                this.updateMultiMediaWithVariant();
            }
        },
        _updateColorSwatch(html) {
          const showSwatchWithVariantImage = document.querySelector(`#variant-update-${ sectionId }`).dataset.showSwatchWithVariantImage;
          const destination = document.querySelector(`#variant-update-${ sectionId } [data-swatch="true"]`);
          if(destination && showSwatchWithVariantImage) {
            const source = html.querySelector(`#variant-update-${ sectionId } [data-swatch="true"]`);
            if (source) destination.innerHTML = source.innerHTML;
          }
        },

        updateMultiMediaWithVariant (){

            this._validateOption()

            const scope = `
                :is(
                    #ProductModal-${ sectionId } ,
                    #shopify-section-${ sectionId }
                )
            `

            const variant = this.currentVariant

            const featured = variant.featured_media


            if( ! variant ){

                if( this.initfirstMedia ){

                    const medias = document
                        .querySelectorAll(`${ scope } [ data-media-options ]`)

                    Array
                    .from(medias)
                    .reverse()
                    .forEach(({ classList , dataset }) => {

                        dataset.mediaActive = String( true )

                        if( classList.contains('media-slide') )
                            classList.add('splide__slide')
                    })
                }

                return
            }


            const selectors = Object
                .entries(this.mediaOptions)
                .map(([ key ]) => {

                    const input = document
                        .querySelector(`
                            #shopify-section-${ sectionId }
                            [ data-option-name = '${ key }' ]
                        `)

                    if( ! input )
                        return null

                    const index = input.dataset.optionIndex

                    const value = variant.options[ index ]

                    const handle = this._handleText(value)

                    return `${ key }:${ handle }`
                })
                .filter(( selector ) => selector )

            if( selectors.length ){

                const selector = `
                    ${ scope }
                    [ data-media-options = '${ selectors.join(',') }' ]
                `

                let variantMedias = document
                    .querySelectorAll(selector)


                let showFeatured = false

                if ( ! variantMedias.length ){

                    const mediaId = featured?.id

                    const mediaUId = `${ sectionId }-${ mediaId }`

                    const selector = ( mediaId )
                        ? `${ scope } [ data-media-options = '${ mediaUId }' ]`
                        : `${ scope } [ data-media-options ].featured-image`

                    variantMedias = document
                        .querySelectorAll(selector)

                    if( ! mediaId )
                        showFeatured = true
                }

                if( ! variantMedias.length ){

                    document
                    .querySelectorAll(`${ scope } [ data-media-options ]`)
                    .forEach(({ classList , dataset}) => {

                        dataset.mediaActive = String( true )

                        classList.add('splide__slide')
                    })

                    const splideEl = document
                        .getElementById(`x-product-${ sectionId }`);

                    if( splideEl.splide ){
                        splideEl.splide.refresh();
                        splideEl.splide.go(0);
                    }

                    const splideZoomEl = document
                        .getElementById(`media-gallery-${ sectionId }`);

                    splideZoomEl.splide?.refresh()

                    return
                }


                const mediaActive = document
                    .querySelectorAll(`${ scope } [ data-media-options = '' ]`)

                const newMedias = [
                    ... mediaActive ,
                    ... variantMedias
                ]

                let productMedias = document
                    .querySelectorAll(`${ scope } [ data-media-options ]`)

                this._setActiveMedia(productMedias,newMedias)

                let splideEl = document
                    .getElementById(`x-product-${ sectionId }`);

                if (splideEl.splide) {
                    splideEl.splide.refresh();
                    splideEl.splide.go(0);
                }

                let splideZoomEl = document
                    .getElementById(`media-gallery-${ sectionId }`);

                splideZoomEl.splide?.refresh();

                if( showFeatured )
                    this._goToFirstSlide()

            } else {

                const featured = this.currentVariant.featured_media

                const mediaId = featured?.id

                const mediaUId = `${ sectionId }-${ mediaId }`

                const selector = ( mediaId )
                    ? `${ scope } [ data-media-options = '${ mediaUId }' ]`
                    : `${ scope } [ data-media-options ].featured-image`

                const variantMedias = document
                    .querySelectorAll(selector)


                let productMedias = document
                    .querySelectorAll(`${ scope } [ data-media-options ]`)

                const mediaActive = document
                    .querySelectorAll(`${ scope } [ data-media-options = '' ]`)


                const newMedias = [
                    ... mediaActive ,
                    ... variantMedias
                ]

                this._setActiveMedia(productMedias,newMedias,[ ... variantMedias ])

                let splideEl = document
                    .getElementById(`x-product-${ sectionId }`);

                if( splideEl.splide ){
                    splideEl.splide.refresh();
                    splideEl.splide.go(0);
                }

                let splideZoomEl = document
                    .getElementById(`media-gallery-${ sectionId }`);

                splideZoomEl.splide?.refresh();
            }
        },

        _validateOption (){

            const selector = `
                #shopify-section-${ sectionId }
                [ data-media-options ]
            `

            const media = document
                .querySelector(selector)

            if( ! media )
                return

            const value = media.dataset.mediaOptions

            const parts = value.split(',')

            const entries = parts
                .map(( value ) => value.split(':') )

            this.mediaOptions = Object
                .fromEntries(entries)

            console.debug('_validateOption',{
                mediaOptions : this.mediaOptions
            })
        },

        _setActiveMedia (
            productMedias ,
            newMedias ,
            activeMedia = []
        ){

            productMedias.forEach(({ classList , dataset }) => {
                dataset.mediaActive = String( false )
                classList.remove('splide__slide','x-thumbnail')
            })

            Array
            .from(newMedias)
            .reverse()
            .forEach(( newMedia ) => {

                newMedia.dataset.mediaActive = String ( true )

                if( newMedia.classList.contains('media-thumbnail') )
                    newMedia.classList.add('x-thumbnail')

                if( newMedia.classList.contains('media-slide') )
                    newMedia.classList.add('splide__slide')

                const parent = newMedia.parentElement

                if( parent.firstChild == newMedia )
                    return

                if( ! Array.from(activeMedia).includes(newMedia) )
                    return

                parent.prepend(newMedia)
            })
        },

        _handleText ( value ){
            return value
                ?.toString()
                .replace('ı','i')
                .replace('ß','ss')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g,'')
                .toLowerCase()
                .trim()
                .replace(/[^a-z0-9]/g,'-')
                .replace(/-+/g,'-')
                .replace(/^-+/g,'')
                .replace(/-+$/g,'')
        },

        _goToFirstSlide() {
          if (this.currentVariant && !this.currentVariant.featured_image) {
            let splideEl = document.getElementById("x-product-" + sectionId);
            if (splideEl) {
              if (splideEl.splide && this.currentVariant && this.currentVariant.featured_image != null) {
                splideEl.splide.go(0);
              }
            }

            let activeEL = document.querySelector(`#stacked-${sectionId} .featured-image`);
            let stackedEL = document.getElementById('stacked-' + sectionId);
            if(stackedEL && activeEL) stackedEL.prepend(activeEL);
          }
        },

        onChange (){

            this._resetQuantity()

            if( this.isChange )
                return

            const parent = this.$el.parentNode

            const { optionName } = parent.dataset

            this.isChange = !! optionName
        },


        _resetQuantity (){

            window.dispatchEvent(new CustomEvent('product:quantity:set',{
                detail : { value : 1 }
            }))
        },


        _updateMasterId (){

            const { variants , options } = this

            this.currentVariant = variants.find(( variant ) => {
                return ! variant.options.find(( option , index ) =>
                    option.replaceAll('\\/','/') !== options[ index ])
            })
        },


        _findAvailableVariant (){

            let { variants , options } = this

            options.forEach(( option , index ) => {

                console.debug('Trying',{option,index,variants,options})

                const matching = variants
                    .filter(( variant ) => ! variant.hidden )
                    .filter(( variant ) => variant.options[ index ].replaceAll('\\/','/') === option )

                console.debug('Trying',matching)

                if( matching.length )
                    variants = matching
            })

            console.debug('Available',variants)

            return variants.at(0)
        },


        _updateVariantInput() {
          const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}, #product-form-sticky-${sectionId}`);
          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (!input) return;
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          })
        },
        _updateProductForms() {
          const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}, #product-form-sticky-${sectionId}`);
          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (input) {
              input.value = this.currentVariant.id;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        },
        _renderPriceProduct(html) {
          const destination = document.getElementById('price-' + sectionId);
          const source = html.getElementById('price-' + sectionId);

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _renderSkuProduct(html) {
          const destination = document.getElementById('sku-' + sectionId);
          const source = html.getElementById('sku-' + sectionId);

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _renderProductBadges(html) {
          const destination = document.getElementById('x-badges-' + sectionId);
          const source = html.getElementById('x-badges-'+ sectionId);

          if (source && destination) destination.innerHTML += source.innerHTML;
        },

        _renderBuyButtons ( html ){

            const forms = document.querySelectorAll(`
                #product-form-installment-${ sectionId } ,
                #product-form-sticky-${ sectionId } ,
                #product-form-${ sectionId }
            `)

            const atcSource = html.getElementById('x-atc-button-' + sectionId)

            forms.forEach(( form ) => {

                const atcDestination = form
                    .querySelector('.add_to_cart_button');

                if( ! atcDestination )
                    return

                if( atcSource && atcDestination )
                    atcDestination.innerHTML = atcSource.innerHTML

                console.debug({ available : this.currentVariant.available })

                if( this.currentVariant?.available && ! this.currentVariant.hidden ){

                    /// Enable add to cart button
                    atcDestination.dataset.available = "true";

                    if( html.getElementById('form-gift-card-' + sectionId) ){

                        if(
                            document.getElementById('Recipient-checkbox-' + sectionId).checked &&
                            document.getElementById('recipient-form-' + sectionId).dataset.disabled == "true"
                        ){
                            atcDestination.setAttribute('disabled', 'disabled')
                        } else {
                            atcDestination.removeAttribute('disabled');
                        }

                    } else {
                        atcDestination.removeAttribute('disabled');
                    }

                } else {
                    atcDestination.dataset.available = "false";
                    atcDestination.setAttribute('disabled', 'disabled');
                    console.debug(`Setting disabled`)
                }
            })

            const paymentButtonDestination = document.getElementById('x-payment-button-' + sectionId);
            const paymentButtonSource = html.getElementById('x-payment-button-' + sectionId);
            if (paymentButtonSource && paymentButtonDestination) {
                if (paymentButtonSource.classList.contains('hidden')) {
                paymentButtonDestination.classList.add('hidden');
                } else {
                paymentButtonDestination.classList.remove('hidden');
                }
            }
        },

        _setMessagePreOrder(html) {
          const msg = document.querySelector(`.pre-order-${sectionId}`);
          if (!msg) return;
          msg.classList.add('hidden');
          const msg_pre = html.getElementById(`pre-order-${sectionId}`);
          if (msg_pre) {
            msg.classList.remove('hidden');
            msg.innerHTML = msg_pre.innerHTML;
          }
        },
        _setEstimateDelivery(html) {
          const est = document.getElementById(`x-estimate-delivery-${sectionId}`);
          if (!est) return;
          const est_res = html.getElementById(`x-estimate-delivery-${sectionId}`);
          if (est_res.classList.contains('disable-estimate')) {
            est.classList.add('hidden');
          } else {
            est.classList.remove('hidden');
            est.innerHTML = est_res.innerHTML;
          }

          const estimateDeliveryCart = document.querySelectorAll(`.cart-edt-${sectionId}`);
          const estimateDeliveryCartUpdate = html.querySelectorAll(`.cart-edt-${sectionId}`);
          if (estimateDeliveryCart.length > 0 && estimateDeliveryCartUpdate.length > 0) {
            estimateDeliveryCart.forEach((item, index) => {
              item.innerHTML = estimateDeliveryCartUpdate[index].innerHTML;
            })
          }
        },
        _setTableOfInformation(html) {
          const toc_arr = document.querySelectorAll(`.table_info_details-${sectionId}`);
          const toc_res_arr = html.querySelectorAll(`.table_info_details-${sectionId}`);
          if (toc_arr.length > 0 && toc_res_arr.length > 0) {
            toc_arr.forEach((toc, index) => {
              toc.innerHTML = toc_res_arr[index].innerHTML;
            })
          }
        },
        _setPreorderProperties(html) {
          const preorder = document.getElementById(`preorder-${sectionId}`);
          const preorder_res = html.getElementById(`preorder-${sectionId}`);
          if (preorder && preorder_res) preorder.innerHTML = preorder_res.innerHTML;
        },
        _setCartEstimateDelivery(html) {
          const est = document.getElementById(`cart-edt-${sectionId}`);
          const est_res = html.getElementById(`cart-edt-${sectionId}`);
          if (est && est_res) est.innerHTML = est_res.innerHTML;
        },
        _setBackInStockAlert(html) {
          const destination = document.getElementById(`back_in_stock_alert-${sectionId}`);
          const source = html.getElementById(`back_in_stock_alert-${sectionId}`);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _setPickupPreOrder(html) {
          const pickup = document.getElementById(`pickup-pre-order-${sectionId}`);
          if (!pickup) return;
          const pickup_res = html.getElementById(`pickup-pre-order-${sectionId}`);
          if (pickup_res.classList.contains('disable-pickup')) {
            pickup.classList.add('hidden');
          } else {
            pickup.classList.remove('hidden');
          }
        },
        _setUnavailable() {
          const price = document.getElementById(`price-` + sectionId);
          if (price) price.classList.add('hidden');

          const priceDesktop = document.getElementById(`price-sticky-${sectionId}`);
          if (priceDesktop) priceDesktop.classList.add('hidden');

          const inventory = document.getElementById(`block-inventory-` + sectionId);
          if (inventory) inventory.classList.add('hidden');

          const badges = document.getElementById(`x-badges-` + sectionId);
          if (badges) badges.classList.add('hidden');

          const pickup = document.getElementById(`pickup-` + sectionId);
          if (pickup) pickup.classList.add('hidden');

          const quantity = document.getElementById('x-quantity-' + sectionId);
          if (quantity) quantity.classList.add('unavailable');

          const msg_pre = document.querySelector(`.pre-order-${sectionId}`);
          if (msg_pre) msg_pre.classList.add('hidden');

          const sku = document.getElementById('sku-' + sectionId);
          if (sku) sku.classList.add('hidden');
          const back_in_stock_alert = document.getElementById(`back_in_stock_alert-${sectionId}`);
          if (back_in_stock_alert) back_in_stock_alert.classList.add('hidden');

          this._setBuyButtonUnavailable();
        },
        _setAvailable() {
          const price = document.getElementById(`price-` + sectionId);
          if (price) price.classList.remove('hidden');

          const inventory = document.getElementById(`block-inventory-` + sectionId);
          if (inventory) inventory.classList.remove('hidden');

          const badges = document.getElementById(`x-badges-` + sectionId);
          if (badges) badges.classList.remove('hidden');

          const pickup = document.getElementById(`pickup-` + sectionId);
          if (pickup) pickup.classList.remove('hidden');

          const quantity = document.getElementById('x-quantity-' + sectionId);
          if (quantity) quantity.classList.remove('unavailable');

          const sku = document.getElementById('sku-' + sectionId);
          if (sku) sku.classList.remove('hidden');

          const back_in_stock_alert = document.getElementById(`back_in_stock_alert-${sectionId}`);
          if (back_in_stock_alert) back_in_stock_alert.classList.remove('hidden');
        },
        _setBuyButtonUnavailable() {
          const productForms = document.querySelectorAll(`#product-form-${sectionId},  #product-form-sticky-${sectionId}`);
          productForms.forEach((productForm) => {
            const addButton = productForm.querySelector('.add_to_cart_button');
            if (!addButton) return;
            addButton.setAttribute('disabled', 'disabled');
            const addButtonText = addButton.querySelector('.x-atc-text');
            if (addButtonText) addButtonText.textContent = unavailableText;
          });
        },


        _dispatchUpdateVariant( html = '' ){

            const name = `eurus:product-card-variant-select:updated:${ sectionId }`

            const detail = {
                currentAvailableOptions : this.currentAvailableOptions ,
                existingOptions : this.existingOptions ,
                currentVariant : this.currentVariant,
                options : this.options ,
                html : html
            }

            const event = new CustomEvent(name,{ detail })

            document.dispatchEvent(event)
        },


        _updateImageVariant() {
          if (this.currentVariant != null) {
            let featured_image = ""
            if (this.currentVariant.featured_image != null) {
              featured_image = this.currentVariant.featured_image.src;
            }
            Alpine.store('xPreviewColorSwatch')?.updateImage(this.$el, productUrl, featured_image, this.currentVariant.id, sectionId)
          }
        },
        initEventSticky() {
          document.addEventListener(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, (e) => {
            this.handleSticky = e.detail.variantElSticky;
            this.updateVariantSelector(e.detail.inputId, e.detail.targetUrl);
          });
        },
        changeSelectOption(event) {
          Array.from(event.target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
            event.target.selectedOptions[0].setAttribute('selected', 'selected');
          const input = event.target.selectedOptions[0];
          const inputId = input.id;
          const targetUrl = input.dataset.productUrl;
          this.updateVariantSelector(inputId, targetUrl);
        },
        updateVariantSelector(inputId, target) {

          this._resetQuantity()

          if (productBundle) {
            this.handleSectionId = handleSectionId;
          }
          this.currentVariant = this._getVariantData(inputId);
          let updateFullpage = false;
          let callback = () => {};

          const targetUrl = target || element.dataset.url;
          if (element.dataset.url !== targetUrl) {
            if (element.closest('#quickview-product-content')) {
              Alpine.store('xQuickView').load(targetUrl);
              return;
            }
            this._updateURL(targetUrl);
            this._setAvailable();
            if (this.isProductPage) {
              updateFullpage = true;
            }
            callback = (html) => {
              this._handleSwapProduct(sectionId, html, updateFullpage);
              this._renderCardFBT(html);
              this._dispatchUpdateVariant(html);
            };
          } else if (!this.currentVariant) {
            this._setUnavailable();
            callback = (html) => {
              this._updateOptionValues(html);
              this._dispatchVariantSelected(html);
              this._dispatchUpdateVariant(html);
            };
          } else {
            this._updateURL(targetUrl);
            this._updateVariantInput();
            this._setAvailable();
            callback = (html) => {
              this._handleUpdateProductInfo(html);
              this._updateOptionValues(html);
              this._updateMedia(html);
              this._handleAvailable(html);
            }
          }
          this._renderProductInfo(targetUrl, callback, updateFullpage);
        },
        _renderProductInfo(url, callback, updateFullpage) {
          let link = "";
          let params = `option_values=${this._getSelectedOptionValues().join(',')}`;
          if ( productBundle) {
            params = `option_values=${this._getSelectedOptionValues().join(',')}&page=${pageParam}`;
          }
          link = updateFullpage?`${url}?${params}`:`${url}?section_id=${this.handleSectionId}&${params}`;

          if (this.cachedResults[link]) {
            const html = this.cachedResults[link];
            callback(html);
          } else {
            fetch(link)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                callback(html);
                this.cachedResults[link] = html;
              })
          }
          this.handleSticky = '';
        },
        _handleUpdateProductInfo(html) {
            this._renderCardFBT(html);
            this._renderPriceProduct(html);
            this._renderProductBadges(html);
            this._renderInventoryStatus(html);
            this._renderSkuProduct(html);
            this._renderBuyButtons(html);
            this._setMessagePreOrder(html);
            this._setEstimateDelivery(html);
            this._setTableOfInformation(html);
            this._setPickupPreOrder(html);
            this._setCartEstimateDelivery(html);
            this._setPreorderProperties(html);
            this._setBackInStockAlert(html);
            if (!productBundle) {
              Alpine.store('xUpdateVariantQuanity').render(html, this.handleSectionId);
            }
            this._dispatchUpdateVariant(html);
            this._dispatchVariantSelected(html);
            this._updateOptionValues(html);
            Alpine.store('xPickupAvailable').updatePickUp(sectionId, this.currentVariant.id);

        },
        initFirstAvailableVariant(el) {
          this.currentVariant = JSON.parse(el.querySelector(`script[type="application/json"][data-selected-variant]`).textContent);
          if (!productBundle) {
            document.addEventListener('eurus:cart:items-changed', () => {
              this.cachedResults = [];
              Alpine.store('xUpdateVariantQuanity').updateQuantity(sectionId, productUrl, this.currentVariant?.id);
            });
          }
        },
        _handleAvailable(html) {
          const selectedVariant = html.querySelector('.variant-selects [data-selected-variant]')?.innerHTML;
          if (selectedVariant == 'null') {
            this._setUnavailable();
          }
        },
        _updateOptionValues(html) {
          if (!productBundle) {
            const variantSelects = html.querySelector('.variant-selects');
            if (variantSelects) element.innerHTML = variantSelects.innerHTML;
          }
        },
        _getVariantData(inputId) {
          return JSON.parse(this._getVariantDataElement(inputId).textContent);
        },
        _getVariantDataElement(inputId) {
          return element.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
        },

        _updateURL ( target ){

            console.debug('Variant-Select::UpdateURL',{
                isProductPage : this.isProductPage ,
                target
            })

            if( ! this.isProductPage )
                return

            const variant = this.currentVariant?.id

            const url = new URL(target,location.href)

            if( variant )
                url.searchParams.set('variant',variant)

            history.replaceState(history.state,'',url.href)
        },

        _getSelectedOptionValues() {
          if (this.handleSticky == '') {
            return Array.from(element.querySelectorAll('select option[selected], fieldset input:checked')).map(
              (e) => e.dataset.optionValueId
            );
          } else {
            return Array.from(this.handleSticky.querySelectorAll('select option[selected]')).map(
              (e) => e.dataset.optionValueId
            );
          }
        },

        _renderCardFBT(html) {
          const destination = element.closest(".card-product-fbt");
          const source = html.querySelector('.card-product-fbt-clone .card-product-fbt');

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _handleSwapProduct(sectionId, html, updateFullpage) {
          if (updateFullpage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            const destination = document.querySelector('main');
            const source = html.querySelector('main');
            if (source && destination) destination.innerHTML = source.innerHTML;
          } else {
            const destination = document.querySelector('.x-product-' + sectionId);
            const source = html.querySelector('.x-product-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        }
      }))
    });
  });


  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xPickupAvailable', {
        updatePickUp(id, variantId) {
          const container = document.getElementsByClassName('pick-up-'+ id)[0];
          if (!container) return;

          fetch(window.Shopify.routes.root + `variants/${variantId}/?section_id=pickup-availability`)
            .then(response => response.text())
            .then(text => {
              const pickupAvailabilityHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('.shopify-section');

              container.innerHTML = pickupAvailabilityHTML.innerHTML;
            })
            .catch(e => {
              console.error(e);
            });
        }
      });
    });
  });

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xUpdateVariantQuanity', {
        updateQuantity(sectionId, productUrl, currentVariant) {
          const quantity = document.getElementById('x-quantity-' + sectionId);
          if (!quantity) return;
          const url = currentVariant ? `${productUrl}?variant=${currentVariant}&section_id=${sectionId}` :
                        `${productUrl}?section_id=${sectionId}`;
          fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              let html = new DOMParser().parseFromString(responseText, 'text/html');
              this.render(html, sectionId);
            });
        },
        render(html, sectionId) {
          const destination = document.getElementById('x-quantity-' + sectionId);
          const source = html.getElementById('x-quantity-'+ sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        }
      });
    });
  });
}
